import { zodResolver } from '@hookform/resolvers/zod';
import { schema, Schema } from './round-form.schema';
import { Button } from '~/components/Button/Button';
import { Grid } from '~/components/Grid/Grid';
import { Input } from '~/components/Input';
import { useForm } from 'react-hook-form';

interface Props {
  onSubmit: (data: Schema) => void;
  mode: 'create' | 'edit';
  defaultValues?: Schema;
  isLoading: boolean;
}

export function RoundForm({ defaultValues, mode, isLoading, onSubmit }: Props) {
  const { formState, register, handleSubmit } = useForm({
    defaultValues: defaultValues ?? {},
    resolver: zodResolver(schema),
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
      <Grid>
        <Grid.Item cols={{ sm: 12, md: 6 }}>
          <Input.Group formState={formState} htmlFor="name" label="Namn">
            <Input.Field type="text" {...register('name')} />
          </Input.Group>
        </Grid.Item>

        <Grid.Item cols={{ sm: 12, md: 6 }}>
          <Input.Group formState={formState} htmlFor="start" label="Start">
            <Input.Field type="date" {...register('start')} />
          </Input.Group>
        </Grid.Item>
      </Grid>

      <Grid>
        <Grid.Item cols={{ sm: 12, md: 6 }}>
          <Input.Group formState={formState} htmlFor="end" label="Slut">
            <Input.Field type="date" {...register('end')} />
          </Input.Group>
        </Grid.Item>
      </Grid>

      <Button.Group align="right">
        <Button type="submit" isLoading={isLoading}>
          {{ create: 'Skapa', edit: 'Spara' }[mode]}
        </Button>
      </Button.Group>
    </form>
  );
}
